var start = new Date().getTime();
gsap.registerPlugin(ScrollTrigger, SplitText);

var isRTL = $("html").attr("lang") === "ar",
    winWidth = $(window).width(),
    winHeight = $(window).height(),
    isMobile = false,
    pageLoadTL = gsap.timeline({ paused: true }),

    backToTopBtn = $('.back-to-top'),
    heading = document.querySelector("[data-split-words][data-animation-transition]"),
    splitWords = new SplitText(heading, { type: "words", wordsClass: "single-word" }),

    heading2 = document.querySelectorAll("[data-split-words][data-animation-scroll]"),
    splitWords2 = new SplitText(heading2, { type: "words", wordsClass: "single-word" }),

    fadeInUpTxt = document.querySelectorAll('[data-animation-transition="fadeInUp"]'),
    fadeInUpScroll = document.querySelectorAll('[data-animation-scroll="fadeInUp"]'),
    emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    letters = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
$('[data-split-words] .single-word').wrapInner('<div class="single-word-inner">');

var match_Media = gsap.matchMedia();
function scrollAnimation() {
    end = new Date().getTime();
    var timeload = end - start;

    // console.log("scrollAnimation",timeload);
    if ($(window).width() >= 768) {
        if (heading2) {
            $(".bannerText").addClass('animationTriggered');
            $(heading2).each(function () {
                let delay = $(this).data('delay') || 0;
                let triggerElement = $(this);
                let targetElement = $(this).find('.single-word-inner');
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: triggerElement,
                        start: "0% 90%",
                        end: "100% 0%",
                        toggleActions: "play none none none",
                        once: true
                    }
                });

                tl.fromTo(targetElement, {
                    yPercent: 120,
                    rotate: 0.001,
                    ease: "primary-ease",
                    duration: 0.5,
                }, {
                    yPercent: 0,
                    rotate: 0.001,


                    stagger: 0.15,
                    // clearProps: "all",
                    autoAlpha: 1,
                    delay: delay,
                });
            });
        }

        if (document.querySelectorAll('[data-animation-scroll="fadeInUp"]')) {
            $('[data-animation-scroll="fadeInUp"]').each(function () {
                let triggerElement = $(this);
                let targetElement = $(this);

                let delay = $(this).data('delay') || 0;

                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: triggerElement,
                        start: "0% 90%",
                        end: "100% 0%",
                        toggleActions: "play none none none"
                    }
                });

                tl.fromTo(targetElement, {
                    y: "1em",
                    rotate: 0.001,
                    autoAlpha: 0
                }, {
                    y: 0,
                    rotate: 0.001,
                    autoAlpha: 1,
                    ease: "primary-ease",
                    duration: 0.2,
                    stagger: 0.2,
                    delay: delay,
                    // clearProps: "all"
                }, 0.2);
            });
        }


        //   fade in right
        if (document.querySelectorAll('[data-animation-scroll="fadeInRight"]')) {
            $('[data-animation-scroll="fadeInRight"]').each(function () {
                let triggerElement = $(this);
                let targetElement = $(this);

                let delay = $(this).data('delay') || 0;

                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: triggerElement,
                        start: "0% 90%",
                        end: "100% 0%",
                        toggleActions: "play none none none"
                    }
                });

                tl.fromTo(targetElement, {
                    x: "2em",
                    rotate: 0.001,
                    autoAlpha: 0,
                    // duration: .5
                }, {
                    x: 0,
                    rotate: 0.001,
                    autoAlpha: 1,
                    ease: "primary-ease",
                    duration: 1,
                    delay: delay,
                    // clearProps: "all"
                }, 0.2);
            });
        }
    }
}
function animateElements() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("animateElements",timeload);
    if ($(".animate").length > 0) {
        $(".animate").bind("inview", function (event, isInview) {
            if (isInview) {
                let aniamte = $(this).attr("data-animation");
                let speedDuration = $(this).attr("data-duration");
                let $t = $(this);
                setTimeout(function () {
                    $t.addClass(aniamte + " animated");
                }, speedDuration);
            }
        })
    }
}


function pageLoading() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("pageLoading",timeload);
    if ($(window).width() >= 768) {
        pageLoadTL.fromTo(".header", { duration: .8, y: '-100%', ease: "Power0.easeNone", autoAlpha: 0 }, { y: '0', autoAlpha: 1 });
        if ('[data-split-words]') {
            pageLoadTL.play().then(function () {
                // animateElements();
                scrollAnimation();
                // initSplitLines();
            })
            //     }

            // })

        }


    }

}




function initSplitLines() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("initSplitLines",timeload);
    var splitTextLines = new SplitText("[data-split-lines='not-split']", {
        type: "lines",
        linesClass: "single-line"
    });
    $('[data-split-lines="not-split"] .single-line').wrapInner('<div class="single-line-inner">');
    $(splitTextLines.elements).each(function () {
        if ($(this).attr('data-split-lines') == 'not-split') {
            $(this).attr('data-split-lines', 'is-split');
        }
    });




    if (document.querySelector('[data-split-lines][data-animation-scroll]')) {
        $(' [data-split-lines][data-animation-scroll]').each(function () {
            let triggerElement = $(this);
            let targetElement = $(this).find('.single-line-inner');

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: triggerElement,
                    start: "0% 90%",
                    end: "100% 0%",
                    toggleActions: "play none none none"
                }
            });

            tl.fromTo(targetElement, {
                yPercent: 120,
                rotate: 0.001,
                autoAlpha: 0
            }, {
                yPercent: 0,
                rotate: 0.001,
                autoAlpha: 1,
                ease: "primary-ease",
                duration: 0.3,
                stagger: 0.2
            });
        });
    }

}


/* Page Loading */
$(function () {
    if (winWidth < 767) {
        isMobile = true
    }
    browserDetect();
});
// // scope define
$(window).on('resize orientationchange', function () {
    latestNews();
    sectorSliders();
    mapSec();
    $(".content").mCustomScrollbar("destroy");
    initializeCustomScrollbar();
}, true);

$(window).on("load", function () {

    //    animateElements();
    //    pageLoading();
    animSpiltText();

})



$(document).ready(function () {
    // animateText();
    if (backToTopBtn.length > 0) {
        setTimeout(() => {
            backToTopBtn.on('click', function () {
                $('html, body').animate({ scrollTop: 0 }, 'smooth');
            });
        }, 100);

    }

    animateElements();
    pageLoading();
    footerScroll();
    videoHover();
    clickedVideo();
    generalSlider();
    programSlider();
    latestNews();
    //    basicSelect2();
    ChangeToSvg();
    internationalInput();
    sectorSliders();
    evolutionProgram();
    partnerSlider();
    processSwiper();
    generalStickySide();

    infoSlider();
    editorialBlockAnimation();
    openMenu();
    headerScrolling();
    smoothScrolling();
    closeMenu();
    dropdownAnim();
    scrollTosec();
    DrawerOpen();
    filterBoxDropdown();
    initializeCustomScrollbar();
    applyCounterLogic();
    //    ourValuesBg();
    moreLikeSlider();
    researchslider();
    ourValueSlider();
    setTimeout(() => {
        animateSVG();
        footerAnimation();
    }, 100);

    calculateExpandWidth();
    animBuildingProperity();
    ourAmbitiousAnim();
    mapSec();
    //    imgParallex();
    eligibilityImges();
    gsapImageParallax();
    accordionAnimate();

    makeStickyEligibility();
    messageCharacterCount();
    //    initSelect2('.js-select2');
    intlTelInputInit();
    //    initValidation('.contact-form');
    // progressBarClickItem();
    setTimeout(() => {
        contactStickySide();
        makeStickyDetailNews();

    }, 500);

});

//Beowser Detect

function browserDetect() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("browserDetect",timeload);
    navigator.sayswho = (function () {
        var ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return tem.slice(1).join('').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    })();
    $('body').addClass(navigator.sayswho);
}

function animateText() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("animateText",timeload);
    // const heading = document.querySelector(".animated-heading");

    // Get duration from data attribute and convert it to seconds (GSAP uses seconds, while data attribute is in milliseconds)
    const duration = parseFloat(heading.dataset.duration) / 1000;

    // Split the text by words
    // const splitText = new SplitText(heading, { type: "words" });

    // Animate each word with the duration set from the data attribute
    gsap.fromTo(splitWords.words, { yPercent: 100, rotate: 0.001, opacity: 0, ease: "expo.out", overflow: "hidden", }, { opacity: 1, yPercent: 0, rotate: 0.001, ease: "expo.out", duration: 0.5, stagger: 0.15, });
}

function vhToPx(params) {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("vhToPx",timeload);
    const windowHeight = $(window).height();
    const pxValue = (params * windowHeight) / 100;
    return pxValue;
}

//Parallax Image 
function gsapImageParallax() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("gsapImageParallax",timeload);
    const element = $('.parallexParent');
    if (element.length > 0 && $(window).width() > 1024) {
        const translateValueInVh = isMobile ? 5 : 6;
        const endPoint = `bottom 0%`;
        const scrubValue = 1.1;
        const isMarkers = false;
        element.each(function () {
            const animateTriggerElement = $(this);
            const animelement = animateTriggerElement.find('.parallexImg');
            if (animelement.length <= 0) {
                return;
            }
            const translateY_ = vhToPx(translateValueInVh);
            const actualHeightEleWrapper = animelement.height();
            animelement.height(actualHeightEleWrapper + translateY_);
            const parallaxImgTl = gsap.timeline({
                scrollTrigger: {
                    trigger: animateTriggerElement[0],
                    // start: `${actualHeightEleWrapper}px ${actualHeightEleWrapper / 2}px`,
                    start: "50% 70%",
                    end: endPoint,
                    scrub: scrubValue,
                    markers: isMarkers,
                },
            });
            parallaxImgTl.fromTo(
                animelement[0],
                { y: 0 },
                { y: `-${translateY_}px` }
            );
        });
    }
}


function eligibilityImges() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("eligibilityImges",timeload);
    const contentWrapper = $(".eligibility-app-process .step");
    const stepsContent = $(".steps-content");
    const firstStep = contentWrapper.first();
    let lastActiveStep = firstStep;

    firstStep.addClass("active");
    contentWrapper.on("mouseenter", function () {
        contentWrapper.removeClass("active");
        $(this).addClass("active");
        lastActiveStep = $(this);
    });

    stepsContent.on("mouseleave", function () {
        contentWrapper.removeClass("active");
        lastActiveStep.addClass("active");
    });

    if ($(window).width() < 767) {
        if (contentWrapper) {
            $(".step .step-body").hide("800");
            $(".step.active .step-body").show("800")
            $(".step").on("click", function () {
                $(".step-body").hide("800")
                $(this).find(".step-body").show("800");
            })
        }

    }
}


$(window).resize(function () {
    initializeCustomScrollbar();
    mapSec();
    gsapImageParallax();

});
$(window).load(function () {
    gsapImageParallax();

});

function initializeCustomScrollbar() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("initializeCustomScrollbar",timeload);
    if (window.innerWidth > 1024) {
        $('.custom-scroll2').mCustomScrollbar(
            { alwaysShowScrollbar: 1, }
        );
        $('.custom-scroll').mCustomScrollbar();
    } else {
        $('.custom-scroll2').mCustomScrollbar("destroy");
        $('.custom-scroll').mCustomScrollbar("destroy");
    }

    if ($(window).width() <= 767) {
        $(".content").mCustomScrollbar({
            axis: "x" // horizontal scrollbar
        });
    }
}

function headerScrolling() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("headerScrolling",timeload);
    const headerTrigger = ScrollTrigger.getById("headerScrollTrigger");
    if (headerTrigger) headerTrigger.kill();

    const header = document.querySelector('.header');


    // Set the header to sticky when the page starts scrolling
    ScrollTrigger.create({
        id: "headerScrollTrigger",
        start: "top top",
        end: "bottom bottom",
        onEnter: () => {
            header.classList.add('headerSticky');
        },
        onLeaveBack: () => {
            header.classList.remove('headerSticky');

        }
    });
}

function generalStickySide() {
    end = new Date().getTime();
    var timeload = end - start;
    // console.log("generalStickySide",timeload);
    const stickyLeft = document.querySelector('.sidemenuMain');
    const rightContent = document.querySelector('.faqs-wrapper');
    const faqLines = document.querySelector('.faq-tab .bottom-lines');

    // Function to create ScrollTriggers dynamically
    const createScrollTriggers = () => {
        // Clear existing ScrollTriggers
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());

        // Sticky Side Menu Pinning
        if (stickyLeft && rightContent) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: stickyLeft,
                    start: 'top-=150 top',
                    end: `+=${rightContent.offsetHeight - stickyLeft.offsetHeight}`,
                    pin: true,
                    scrub: 1,
                },
            });
        }

        // FAQ Bottom Line Pin
        if (faqLines) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: faqLines,
                    start: 'top-=100% top',
                    end: `+=${rightContent.offsetHeight - stickyLeft.offsetHeight - faqLines.offsetHeight}`,
                    pin: true,
                    scrub: 2,
                },
            });
        }
    };

    // Initial ScrollTrigger setup
    createScrollTriggers();

    // Observe height changes and refresh
    const resizeObserver = new ResizeObserver(() => {
        createScrollTriggers(); // Recreate ScrollTriggers on height change
    });

    if (stickyLeft) resizeObserver.observe(stickyLeft);
    if (rightContent) resizeObserver.observe(rightContent);
    if (faqLines) resizeObserver.observe(faqLines);

    // Refresh on window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            createScrollTriggers();
        }, 200);
    });
}

function contactStickySide() {
    const stickyLeft = document.querySelector('.js-stickySidebar');
    const rightContent = document.querySelector('.js-contentWrapper');
    const animatedLines = document.querySelector('.contact-sec .bottom-lines');
    const headerHeight = document.querySelector('.header');
    // console.log(rightContent.offsetHeight, stickyLeft.offsetHeight);

    let stickyTimeline = null;
    let animatedLinesTimeline = null;

    const initializeTimelines = () => {
        if (stickyLeft && rightContent) {
            stickyTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: stickyLeft,
                    start: 'top-=' + headerHeight.offsetHeight + ' top',
                    end: `+=${rightContent.offsetHeight - stickyLeft.offsetHeight}`,
                    pin: true,
                    scrub: 1,
                    markers: false,
                },
            });
        }

        if (animatedLines) {
            animatedLinesTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: animatedLines,
                    start: 'top-=80% top',
                    end: `+=${rightContent.offsetHeight - stickyLeft.offsetHeight - animatedLines.offsetHeight}`,
                    pin: true,
                    scrub: 2,
                },
            });
        }
    };

    const killTimelines = () => {
        if (stickyTimeline) {
            stickyTimeline.kill();
            stickyTimeline = null;
            stickyLeft.style.position = ''; // Reset any GSAP-applied styles
            stickyLeft.style.top = '';
        }
        if (animatedLinesTimeline) {
            animatedLinesTimeline.kill();
            animatedLinesTimeline = null;
        }
    };

    const updateStickyBehavior = () => {
        const viewportWidth = window.innerWidth;

        if (viewportWidth <= 767) {
            killTimelines();
        } else {
            if (!stickyTimeline && !animatedLinesTimeline) {
                initializeTimelines();
            }
        }
    };


    updateStickyBehavior();
    window.addEventListener('resize', updateStickyBehavior);


}

function accordionAnimate() {
    $('.accordion').on('shown.bs.collapse', function (e) {
        $(e.target).closest('.accordion-item').addClass('active');
    });

    // Remove active class on accordion close
    $('.accordion').on('hidden.bs.collapse', function (e) {
        $(e.target).closest('.accordion-item').removeClass('active');
    });
}

function infoSlider() {
    if ($(".infoSlider").length > 0) {
        var swiper = new Swiper(".infoSlider", {
            slidesPerView: 3,
            navigation: {
                nextEl: ".infoSlider .swiper-button-next",
                prevEl: ".infoSlider .swiper-button-prev",
            },
        });
    }
}

function footerAnimation() {
    $('.footerSec').height($('.footer').outerHeight());
    var $footerParent = $('.footerSec');
    var $footer = $('.footer');
    if (($footer.outerHeight() + $('.header').outerHeight() * 1) < $(window).height()) {
        if ($(window).width() > 991 && $footer.length > 0) {
            console.log("True");
            var footerHeight = $footer.outerHeight();
            $footer.css({
                position: 'fixed',
                bottom: '0',
                width: '100%'
            });
            $footerParent.css('height', footerHeight);
        }
    }
}

function videoHover() {

    const videoDom = $(".hoverVideo");
    if (videoDom.length > 0) {
        videoDom.hover(
            function () {
                $(this).get(0).play();
            },
            function () {
                $(this).get(0).pause();
                $(this).get(0).currentTime = 0; // Reset video to start
            }
        );
    }

}

function clickedVideo() {
    $('.clickedVideo a').on('click', function () {
        var video = $(this).siblings('.controlVideo').get(0);
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    });
}

function generalSlider() {
    if ($(".mySwiper").length > 0) {
        var swiper = new Swiper(".mySwiper", {
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

}
function programSlider() {
    var swiper = new Swiper(".js-programSlider", {
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

function latestNews() {
    var swiper = new Swiper(".js-latestNews", {
        slidesPerView: 1.123,
        spaceBetween: 10,
        loop: false,
        breakpoints: {
            1024: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            767: {
                slidesPerView: 2.150,
                spaceBetween: 20,
            },
        },
        navigation: {
            nextEl: ".secLatestNews .swiper-button-next",
            prevEl: ".secLatestNews .swiper-button-prev",
        },
    });
    window.addEventListener('resize', function () {
        //    swiper.update();
        footerAnimation();
    });
}

function researchslider() {
    if ($(window).width() < 768) {
        var swiper = new Swiper(".js-research-slider", {
            slidesPerView: 1.2,
            spaceBetween: 10,
            loop: false,
        });
    }

}

function moreLikeSlider() {
    if ($(window).width() < 768) {
        var swiper = new Swiper(".js-moreLike-slider", {
            slidesPerView: 1.02,
            spaceBetween: 10,
            loop: false,
        });
    }

}

function ChangeToSvg() {
    $("img.js-tosvg").each(function () {
        var $img = $(this);
        var imgID = $img.attr("id");
        var imgClass = $img.attr("class");
        var imgURL = $img.attr("src");
        $.get(
            imgURL,
            function (data) {
                var $svg = $(data).find("svg");
                if (typeof imgID !== "undefined") {
                    $svg = $svg.attr("id", imgID);
                }
                if (typeof imgClass !== "undefined") {
                    $svg = $svg.attr("class", imgClass + " insvg");
                }
                $svg = $svg.removeAttr("xmlns:a");
                if (
                    !$svg.attr("viewBox") &&
                    $svg.attr("height") &&
                    $svg.attr("width")
                ) {
                    $svg.attr(
                        "viewBox",
                        "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
                    );
                }
                $img.replaceWith($svg);
            },
            "xml"
        );
    });
}

function sectorSliders() {
    if ($(".bgSwiper").length > 0) {

        var sectorPagination = new Swiper(".sectorPagination", {
            slidesPerView: 2,
            spaceBetween: 8,
            slidesPerGroup: 1,
            thumbs: {
                swiper: bgSwiper,
            },
            speed: 300,
            breakpoints: {
                768: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                    allowTouchMove: false,
                },
            }
        });
        var bgSwiper = new Swiper(".bgSwiper", {
            spaceBetween: 10,
            slidesPerView: 1,
            effect: "fade",
            speed: 2000,
            //    fadeEffect: {
            //     crossFade: true 
            //     },
            thumbs: {
                swiper: sectorPagination,
            },
        });
        var sectorSwiper = new Swiper(".sectorSwiper", {
            slidesPerView: 1,
            speed: 50,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            thumbs: {
                swiper: bgSwiper,
            },
            navigation: {
                nextEl: ".sectorsImpactSec .swiper-button-next",
                prevEl: ".sectorsImpactSec .swiper-button-prev",
            },
        });

        // Sync all sliders on slide change
        function syncSliders(swiper) {
            let activeIndex = swiper.activeIndex;
            // Sync sectorPagination
            if (sectorPagination.activeIndex !== activeIndex) {
                sectorPagination.slideTo(activeIndex);
            }
            // Sync bgSwiper
            if (bgSwiper.activeIndex !== activeIndex) {
                bgSwiper.slideTo(activeIndex);
            }
            // Sync sectorSwiper
            if (sectorSwiper.activeIndex !== activeIndex) {
                sectorSwiper.slideTo(activeIndex);
            }
        }

        // Add event listeners for slide change to sync all sliders
        sectorPagination.on('slideChange', function () {
            syncSliders(sectorPagination);
        });

        bgSwiper.on('slideChange', function () {
            syncSliders(bgSwiper);
        });

        sectorSwiper.on('slideChange', function () {
            syncSliders(sectorSwiper);
        });

    }
}

// function basicSelect2(){
//    if($(".js-example-basic-single").length > 0){
//        $('.js-example-basic-single').select2();
//    }
// }

function internationalInput() {
    let input = $(".telephone");

    if ($(input).length > 0) {
        window.intlTelInput(input, ({
            autoPlaceholder: "Number",


        }));
    }
}


function partnerSlider() {
    if ($(".partnerSliderWrap").length > 0) {
        var partnerSwiper = new Swiper('.partnerSliderWrap .swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            centeredSlides: false,
            slideToChange: 1,
            autoHeight: false,
            autoWidth: false,
            navigation: {
                nextEl: '.partnersSec .swiper-button-next',
                prevEl: '.partnersSec .swiper-button-prev',
            },
            on: {
                init: function () {
                    updateActiveSlide(this);
                },
                slideChangeTransitionStart: function () {
                    // Temporarily remove the active class during the transition
                    $('.swiper-slide').removeClass('active-slide');
                },
                slideChangeTransitionEnd: function () {
                    // Add the active class to the new active slide after the transition
                    updateActiveSlide(this);
                },
            },
        });

        function updateActiveSlide(swiper) {
            $(swiper.slides).removeClass('active-slide');
            $(swiper.slides[swiper.activeIndex]).addClass('active-slide');
        }
    }

}

function processSwiper() {
    if ($(".processSwiper").length > 0) {
        var partnerSwiper = new Swiper('.processSwiper', {
            slidesPerView: 2.5,
            spaceBetween: 10,
            navigation: {
                nextEl: ".processSec .btnSwiper.swiper-button-next",
                prevEl: ".processSec .btnSwiper.swiper-button-prev",
            },
        })
    }
}

function editorialBlockAnimation() {
    console.clear();
    const goalsWrap = $('.goals-main-wrapper')
    const cards = gsap.utils.toArray(".js-sec-editorial-block-wrapper .editorial-sec-img-wrapper");

    if (!cards.length) {
        console.log("No cards found");
        return;
    }

    if (goalsWrap.length > 0) {

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.goals-main-wrapper',
                start: "top top",
                // end: "+=100",                 
                scrub: true,
                pin: true,
                markers: true
            }
        });

        gsap.set(cards, { y: 0, scale: 0.8 });


        cards.forEach((card, i) => {
            const distance = 350;

            tl.to(card, {
                y: -distance * i,
                transformOrigin: "top center",
                start: "top top",
                scale: 1,
                duration: 1,
                // ease: "power1.out",            
            }, `>+0.35`);
        });

    }
}

function openMenu() {
    $('.hamburger').click(function () {
        $('body, html').addClass('mobMenuOpen');
    });
}

function closeMenu() {
    $('.cross-icon').click(function () {
        $('body, html').removeClass('mobMenuOpen');
        $('.primaryMenu-mob').slideUp();
        $('.main-item').removeClass('active');
    });
}

function dropdownAnim() {
    $('.main-item').on('click', function () {
        var targetMenu = $(this).data('target');
        $('.primaryMenu-mob').not(targetMenu).slideUp();
        $('.main-item').not(this).removeClass('active');

        $(targetMenu).slideToggle();
        $(this).toggleClass('active');
    });

    $('.primaryMenu-mob ul li a').on('click', function (e) {
        if ($(this).attr('href') === '#') {
            e.preventDefault();
        } else {
            window.location.href = $(this).attr('href');
        }

        $('.primaryMenu-mob ul li a').removeClass('active');
        $(this).addClass('active');
    });
}

function scrollTosec() {
    $('.action-explore').on('click', function () {
        $('html, body').animate({
            scrollTop: $('section').eq(1).offset().top
        }, 800);
    });
}

function debounceFunc(func, delay) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), delay);
    };
}

function updateBackgroundImage() {
    const imgElement = document.getElementById('mapImg');
    if (!imgElement) return;
    const desktopImage = imgElement.getAttribute('data-desktop');
    const mobileImage = imgElement.getAttribute('data-mob');
    imgElement.src = window.innerWidth <= 767 ? mobileImage : desktopImage;

}


function applyPosition() {

    const elements = document.querySelectorAll("[latlong-desktop][latlong-mob]");
    const screenWidth = window.innerWidth;

    // Loop through each element
    elements.forEach(elem => {
        const desktopLatLong = elem.getAttribute("latlong-desktop");
        const mobileLatLong = elem.getAttribute("latlong-mob");

        if (desktopLatLong && mobileLatLong) {
            const desktopPosition = desktopLatLong.split(",");
            const mobilePosition = mobileLatLong.split(",");
            const [top, left] = screenWidth > 767 ? desktopPosition : mobilePosition;

            elem.style.top = top;
            elem.style.left = left;
        }

    });
}



window.addEventListener("resize", debounceFunc(updateBackgroundImage, 100));
window.addEventListener("resize", debounceFunc(applyPosition, 100));

function mapSec() {

    const mapSidePop = document.querySelector('.mapSidePop');
    const _mapSec = document.querySelector('.mapSec');
    const bgMap = document.querySelector('.bgMap');
    // const map = document.querySelector('.map');
    const markers = document.querySelectorAll('.marker');
    const innerMarker = document.querySelectorAll('.innerMarker');
    const markersWithoutInnerMarker = Array.from(markers).filter(marker => !marker.classList.contains('innerMarker'));

    const clusterWraps = document.querySelectorAll('.clusterBox');
    const prevBtn = document.querySelector('.generalArrowsBox .prev');
    const nextBtn = document.querySelector('.generalArrowsBox .next');
    const backBtn = document.querySelector('.backBtn');
    const closeBtn = document.querySelector('.mapSidePop .closeBtn');
    const locationInfo = document.querySelectorAll('.location');

    if (mapSidePop) {
        var mapSidePopWidth = mapSidePop.clientWidth;
    }

    let currentMarkerIndex = 0;
    let markersArray = Array.from(markers);
    let originalTransform = 'scale(1) translate(0px, 0px)';
    updateBackgroundImage();
    applyPosition();

    // side modal
    function toggleMapModal(markerId) {
        mapSidePop.classList.remove("close");
        mapSidePop.classList.add("open");
        mapSidePop.setAttribute('data-marker', markerId);
        document.body.classList.add('mapModalOpen');
        document.documentElement.classList.add('mapModalOpen');
        if (mapSidePop.classList.contains('open') && window.innerWidth > 767) {
            bgMap.style.width = `calc(100% - ${mapSidePopWidth}px)`;
        } else {
            bgMap.style.width = '100%';
        }
        $(".mapDetail").addClass("hidden");
        $(".mapContent").addClass("expand");
    }



    markersWithoutInnerMarker.forEach((marker) => {
        marker.addEventListener('click', () => {
            markers.forEach(m => m.classList.remove('active'));
            markers.forEach(m => m.classList.add('outsiderClicked'));
            marker.classList.add('active');
            clusterWraps.forEach(cw => cw.classList.add('outsiderClicked'));
            const markerId = marker.getAttribute('id');
            zoomToMarker(marker);

            const location = marker.getAttribute('data-location');
            locationInfo.forEach(l => l.textContent = location);
            toggleMapModal(markerId);
        });
    });

    innerMarker.forEach((marker) => {
        marker.addEventListener('click', () => {
            innerMarker.forEach(m => m.classList.remove('active'));
            innerMarker.forEach(m => m.classList.add('outsiderClicked'));
            marker.classList.add('active');
            clusterWraps.forEach(cw => cw.classList.add('outsiderClicked'));

            const location = marker.getAttribute('data-location');
            locationInfo.forEach(l => l.textContent = location);
        });
    });

    function zoomToMarker(marker) {
        const markerRect = marker.getBoundingClientRect();
        const mapRect = bgMap.getBoundingClientRect();

        // Calculate the center point of the marker
        const markerCenterX = markerRect.left + markerRect.width / 2;
        const markerCenterY = markerRect.top + markerRect.height / 2;

        // Calculate the map's center point
        const mapCenterX = mapRect.left + mapRect.width / 2;
        const mapCenterY = mapRect.top + mapRect.height / 2;

        // Calculate the required translation offsets
        const offsetX = (mapCenterX - markerCenterX) / 2;
        const offsetY = (mapCenterY - markerCenterY) / 2;

        _mapSec.classList.add("h-100v");

        const offsetTop = bgMap.getBoundingClientRect().top + window.scrollY; // Calculate offset
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        bgMap.style.transform = ` scale(2.2) translate(${offsetX}px, ${offsetY}px)`;
    }

    // Handle clusters
    clusterWraps.forEach(clusterWrap => {
        const countPin = clusterWrap.querySelector(".count span");
        const childCount = clusterWrap.querySelectorAll(".marker").length;
        countPin.innerHTML += childCount;

        const clusterBtn = clusterWrap.querySelector(".count");
        clusterBtn.addEventListener('click', () => {
            clusterWraps.forEach(cw => cw.classList.add('fadelight'));
            clusterWrap.classList.add("opened");
            const firstMarker = clusterWrap.querySelector(".marker");

            if (firstMarker) {
                markers.forEach(m => m.classList.remove('active'));
                markers.forEach(m => m.classList.add('fadelight'));
                firstMarker.classList.add('active');

                const location = firstMarker.getAttribute('data-location');
                locationInfo.forEach(l => l.textContent = location);

                toggleMapModal(firstMarker.getAttribute('id'));
                zoomToMarker(firstMarker);
            }
        });
    });
    // Function to reset the map and UI elements



    function resetMapUI() {
        bgMap.style.transform = originalTransform;
        mapSidePop.classList.remove("open");
        bgMap.style.width = '100%';

        markers.forEach(m => m.classList.remove('active'));
        markers.forEach(m => m.classList.remove('outsiderClicked'));
        markers.forEach(m => m.classList.remove('fadelight'));

        document.querySelectorAll(".mapDetail").forEach(detail => detail.classList.remove("hidden"));
        document.querySelectorAll(".mapContent").forEach(mp => mp.classList.remove("expand"));

        clusterWraps.forEach(c => c.classList.remove('opened'));
        clusterWraps.forEach(cw => cw.classList.remove('fadelight'));
        clusterWraps.forEach(cw => cw.classList.remove('outsiderClicked'));

        document.body.classList.remove('mapModalOpen');
        document.querySelector("html").classList.remove('mapModalOpen');
        _mapSec.classList.remove("h-100v");
    }

    // Event listener for the back button
    if (backBtn) {
        backBtn.addEventListener('click', resetMapUI);
    }

    // Event listener for the close button
    if (closeBtn) {
        closeBtn.addEventListener("click", resetMapUI);
    }

    // Event listener for the Escape key press
    $(document).on('keydown', function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
            resetMapUI();
        }
    });

    // Event listener for the click Outside of the map
    document.addEventListener('click', (event) => {
        if (
            mapSidePop &&
            !mapSidePop.contains(event.target) &&
            !event.target.closest('.marker') &&
            !event.target.closest('.clusterBox')
        ) {
            resetMapUI();
        }
    });



}

// // Split revert function for text animation cleanup
function splitRevert() {
    splitLines.revert();
}

function animSpiltText() {
    const btn = document.querySelector('.detailInfo .primaryBtn');
    const textElements = document.querySelectorAll('.js-anim-spilt-text');
    if (textElements.length > 0 && $(window).width() >= 768) {
        textElements.forEach((text, index) => {
            const splitLines = new SplitText(text, {
                type: "lines",
                linesClass: "js-anim-line-text"
            });

            splitLines.lines.forEach((line) => {
                const wrapper = document.createElement('div');
                wrapper.classList.add('line-wrapper');
                line.parentNode.insertBefore(wrapper, line);
                wrapper.appendChild(line);
            });
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: text,
                    start: "top 80%",
                    end: "bottom 20%",
                }
            });

            // // // Split text animation
            tl.to(text, {
                opacity: 1
            }).to(splitLines.lines, {
                y: 0,
                ease: "power4.out",
                stagger: 0.5,

            })
            if (btn) {
                tl.fromTo(btn, {
                    y: 40,
                    opacity: 0,
                    ease: "power4.out",
                }, {
                    opacity: 1,
                    y: 0
                })
            }

        })
    }
}

// // Function to animate the SVG lines 
function animateSVG() {

    const svgElements = document.querySelectorAll('.js-svg-anim')
    const duration = 2.5;

    if (svgElements.length > 0 && $(window).width() >= 768) {
        svgElements.forEach((svgElem) => {
            const animDelay = svgElem.getAttribute('data-anim-delay')
            const isBottomLine = svgElem.getAttribute('data-is-bottom-line')
            const pathElements = svgElem.querySelectorAll('.path-animate')
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: svgElem,
                }
            });

            tl.fromTo(svgElem, {
                opacity: 0,
            },
                {
                    opacity: 1,
                    duration: 0,
                    delay: animDelay ?? 0
                }
            );
            pathElements.forEach((path, index) => {

                const startValueLTR = index === 0 ? '100% 100%' : '0%';
                const endValueLTR = index === 0 ? '0 100%' : '100%';

                // Flip values for RTL
                const startValue = startValueLTR;
                const endValue = endValueLTR;

                tl.fromTo(path,
                    { drawSVG: isBottomLine ? `100% 100%` : startValue },
                    { drawSVG: isBottomLine ? `0 100%` : endValue, duration: duration, ease: "power2.inOut" },
                    `-=${index === 0 ? 0 : duration}`
                );
            })
        });
    }
}

function scrollFunction() {
    if ($(document).scrollTop() > 100) {
        backToTopBtn.show();
    } else {
        backToTopBtn.hide();
    }
}
$(window).scroll(function () {
    scrollFunction();
});





function DrawerOpen() {
    $('.drawerButton').on('click', function () {
        $('.drawer-box').addClass('drawerOpen');
        $('body').addClass('modalOpen');
        $('html').addClass('modalOpen');
    });

    // close on closeButton
    $('.drawer-box .closeBtn').on('click', function () {
        closeDrawer();
    });

    // close on escape key
    $(document).on('keydown', function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
            closeDrawer();
        }
    });

    // close on outside the drawer
    $(document).on('click', function (event) {
        const $drawerBox = $('.drawer-box');
        if ($drawerBox.hasClass('drawerOpen') && !$(event.target).closest('.drawer-box, .drawerButton').length) {
            closeDrawer();
        }
    });

    // Function to close the drawer
    function closeDrawer() {
        $('.drawer-box').removeClass('drawerOpen');
        $('body').removeClass('modalOpen');
        $('html').removeClass('modalOpen');
    }
}



function ourAmbitiousAnim() {
    const mainAnimSec = document.querySelector('.js-anim-oa-trigger')
    const slideContainer = document.querySelector('.js-anim-oa-container')
    const slides = document.querySelectorAll('.js-anim-oa-card');
    const slidesCounter = document.querySelectorAll('.js-anim-oa-card .js-anim-title');
    const stickyLeft = document.querySelector('.our-ambitious .ao-sticky');
    const rightContent = document.querySelector('.oa-right-grid');

    if (slides.length > 0) {
        if (window.innerWidth < 1025) {
            slides.forEach((slide) => {
                const videoElementPause = slide.querySelector('video')
                if (videoElementPause) {
                    videoElementPause.play();

                }

            });
            document.querySelector('.js-anim-oa-card').classList.remove('active')
            slidesCounter.forEach((slide, index) => {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: slide,
                        start: '0% 95%',
                        end: '100% 95%',
                        // markers:true,
                        // scrub: 1,
                        onEnter: () => setActiveSlide(index, true),
                    },
                })
            })
            return;
        }
        if (stickyLeft && rightContent) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: stickyLeft,
                    start: 'top top',
                    end: $(window).width() > 1025 ? `+=${rightContent.offsetHeight - stickyLeft.offsetHeight}` : `+=${rightContent.offsetHeight - 400}`,
                    pin: true,
                    pinSpacing: true,
                    scrub: 1,
                },
            });
        }
        document.querySelector('.js-anim-oa-card').classList.remove('active')
        const mainAnimTl = gsap.timeline({
            scrollTrigger: {
                trigger: mainAnimSec,
                start: '0% 20%',
                end: '100% 20%',
                scrub: false,
                // markers: true,
                onEnter: () => setActiveSlide(0),
            },
        })
        mainAnimTl.to(slideContainer, {
            y: 0,
            duration: 0.6,
            onComplete: () => {
                slides.forEach((slide, index) => {
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: slide,
                            start: '0% 35%',
                            end: '100% 35%',
                            scrub: 1,
                            onEnter: () => setActiveSlide(index),
                        },
                    })
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: slide,
                            start: '0% 60%',
                            end: '100% 60%',
                            scrub: 1,
                            onLeaveBack: () => setActiveSlide(index == 0 ? index : index - 1),

                        },
                    })
                })
            }
        })
        function setActiveSlide(activeIndex, isMbl = false) {
            const allSlides = document.querySelectorAll('.js-anim-oa-card')
            if (!isMbl) {
                allSlides.forEach(function (slide, index) {
                    slide.classList.remove('active');
                    const videoElementPause = slide.querySelector('video')
                    if (videoElementPause) {
                        videoElementPause.pause();

                    }
                });
            }

            // Add active class to the current slide
            if (activeIndex >= 0 && activeIndex < allSlides.length) {
                allSlides[activeIndex].classList.add('active');
                const videoElementPlay = allSlides[activeIndex].querySelector('video')
                if (videoElementPlay) {
                    videoElementPlay.play()

                }

            }

        }
    }
}

function createCounterHTML(value, element) {
    const container = document.createElement('div');

    // Check for text prefix (e.g., "Top 15" or Arabic "الأول 15")
    const textPrefixMatch = value.match(/^\p{L}+\s+/u);
    let textPrefix = '';
    if (textPrefixMatch) {
        textPrefix = textPrefixMatch[0].trim();
        value = value.replace(textPrefixMatch[0], '');
    }

    // Check for text suffix (e.g., "15 Trillion" or Arabic "15 مليار")
    const textSuffixMatch = value.match(/\s+\p{L}+$/u);
    let textSuffix = '';
    if (textSuffixMatch) {
        textSuffix = textSuffixMatch[0].trim();
        value = value.replace(textSuffixMatch[0], '');
    }

    // Check if the value has a prefix (+, -)
    if (value.startsWith('+') || value.startsWith('-')) {
        const prefixSpan = document.createElement('span');
        prefixSpan.classList.add('prefix');
        prefixSpan.textContent = value[0]; // '+' or '-'
        container.appendChild(prefixSpan);
        value = value.slice(1);
    }

    // Check if the value has a percentage sign
    let isPercentage = false;
    if (value.includes('%')) {
        isPercentage = true;
        value = value.replace('%', '');
    }

    // Handle text prefix if present
    if (textPrefix) {
        const textPrefixSpan = document.createElement('span');
        textPrefixSpan.classList.add('text-prefix');
        textPrefixSpan.textContent = textPrefix;
        container.appendChild(textPrefixSpan);
        container.appendChild(document.createTextNode("\u00A0"));

    }

    // Split value into integer and decimal parts
    const [integerPart, decimalPart] = value.split('.');
    const parts = integerPart.split(',');

    // Process integer part
    parts.forEach((part, partIndex) => {
        [...part].forEach((digit, digitIndex) => {
            const regex = /^-?\d+(\.\d+)?$/;
            if (regex.test(digit.trim())) {
                const digitSpan = document.createElement('span');
                digitSpan.classList.add('digit');
                let digitsHtml = '';

                if (digit != 0) {
                    // Create spans for each digit from 0 to the current digit
                    for (let i = 0; i <= parseInt(digit); i++) {
                        digitsHtml += `${i}</br>`;
                    }
                } else {
                    for (let i = 0; i <= 9; i++) {
                        digitsHtml += `${i}</br>`;
                    }
                    digitsHtml += `0</br>`;
                }

                digitSpan.innerHTML = digitsHtml;
                container.appendChild(digitSpan);

                // Add separator for thousands if applicable
                if (partIndex < parts.length - 1 && digitIndex === part.length - 1) {
                    const separatorSpan = document.createElement('span');
                    separatorSpan.classList.add('digit-separator');
                    separatorSpan.textContent = ',';
                    container.appendChild(separatorSpan);
                }

            }
        });
    });

    // Process decimal part if present
    if (decimalPart) {
        const decimalSeparatorSpan = document.createElement('span');
        decimalSeparatorSpan.classList.add('digit-separator');
        decimalSeparatorSpan.textContent = '.';
        container.appendChild(decimalSeparatorSpan);

        [...decimalPart].forEach((digit) => {
            const digitSpan = document.createElement('span');
            digitSpan.classList.add('digit');
            let digitsHtml = '';

            // Create spans for each digit from 0 to the current digit
            for (let i = 0; i <= parseInt(digit); i++) {
                digitsHtml += `${i}</br>`;
            }

            digitSpan.innerHTML = digitsHtml;
            container.appendChild(digitSpan);
        });
    }

    // Add percentage symbol if needed
    if (isPercentage) {
        const percentSpan = document.createElement('span');
        percentSpan.classList.add('prefix');
        percentSpan.textContent = '%';
        container.appendChild(percentSpan);
    }

    // Handle text suffix if present
    if (textSuffix) {
        const textSuffixSpan = document.createElement('span');
        textSuffixSpan.classList.add('text-prefix');
        textSuffixSpan.textContent = textSuffix;
        container.appendChild(document.createTextNode("\u00A0"));
        container.appendChild(textSuffixSpan);
    }

    if (textPrefixMatch || textSuffixMatch) {
        element.classList.add('has-prefix')
    }

    return container.innerHTML;
}


function applyCounterLogic() {
    //    if(window.innerWidth < 768 ){
    //        return;
    //    }
    const counterElements = document.querySelectorAll('.counter');
    counterElements.forEach((element) => {
        const value = element.textContent.trim();
        const counterHTML = createCounterHTML(value, element);
        element.innerHTML = counterHTML;
    });
}

function evolutionProgram() {
    const yearSwiper = $('.swiper-year-container');
    const sliderWrap = $('.sliderWrap');

    if (yearSwiper.length > 0) {
        const slideroffsetTop = sliderWrap.offset().top;
        let swiper1 = new Swiper(".swiper-year-container", {

            slidesPerView: 2,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                767: {
                    slidesPerView: 5,
                    spaceBetween: 0,
                },
            },
            on: {
                init: function () {
                    // Add 'visited' class to the first slide on initialization
                    this.slides[0].classList.add('visited');

                    // Add click event to each slide
                    this.slides.forEach((slide, index) => {
                        slide.addEventListener('click', () => {
                            setVisitedClasses(index);
                            // Calculate offset
                            $('html, body').animate({ scrollTop: slideroffsetTop - 80 }, 'slow');
                        });
                    });


                    updateYearBg(this.slides[0].querySelector('.yearItem1').getAttribute('data-year'));

                    // Add click event to each slide
                    this.slides.forEach((slide, index) => {
                        slide.addEventListener('click', () => {
                            setVisitedClasses(index);
                            updateYearBg(slide.querySelector('.yearItem1').getAttribute('data-year'));
                        });
                    });


                },
                slideChange: function () {
                    // Update visited classes based on active slide index
                    // setVisitedClasses(this.activeIndex);


                }
            }
        });

        function setVisitedClasses(activeIndex) {
            swiper1.slides.forEach((slide, index) => {
                if (index <= activeIndex) {
                    slide.classList.add('visited');
                } else {
                    slide.classList.remove('visited');
                }
            });
        }

        var swiper2 = new Swiper(".main-slider", {
            spaceBetween: 10,
            speed: 900,
            slideToClickedSlide: true,
            navigation: {
                nextEl: ".secEvolution .swiper-button-next",
                prevEl: ".secEvolution .swiper-button-prev",
            },
            thumbs: {
                swiper: swiper1,
            },

            on: {
                slideChange: function () {

                    const activeSlide = swiper1.slides[swiper2.activeIndex];
                    const year = activeSlide.querySelector('.yearItem1').getAttribute('data-year');
                    updateYearBg(year);

                    // updateProgressBar(swiper2);
                    setVisitedClasses(this.activeIndex);
                    if (swiper2.activeIndex >= 4) {
                        swiper1.slideTo(swiper2.activeIndex);
                    }
                },
                navigationNext: function () {
                    setVisitedClasses(this.activeIndex);
                    // updateYearDisplay(swiper1); 
                },
                navigationPrev: function () {
                    setVisitedClasses(this.activeIndex);
                    // updateYearDisplay(swiper1); 
                }

            },
        });


        function updateYearBg(year) {
            document.querySelector('.background-year').textContent = year;
        }
    }
}

function ourValuesBg() {
    const listBox = $('.listBox');
    const firstListBox = listBox.first();
    $('.listBody').slideUp();
    if (listBox.length > 0) {
        firstListBox.addClass('active');
        firstListBox.find('.listBody').slideDown(0);
    }

    function handleListInteraction(event) {
        if ($(window).width() > 1024) {
            if (listBox.length > 0) {
                const listBody = $(this).find(".listBody");

                if (!listBody.is(":visible")) {
                    // Only slide elements that are not already visible
                    $(".listBody").stop(true, true).slideUp();
                    listBody.stop(true, true).slideDown();

                    // Update the active class
                    if ($(window).width() > 1024) {
                        listBox.removeClass('active');
                        $(this).addClass('active');
                    }
                }
            }
        }
    }

    if (listBox.length > 0) {
        listBox.on('mouseenter', handleListInteraction);
    }

}

var currentDeviceWidth = $(window).width();


function ourValueSlider() {
    let hasRunOnLargeScreen = false;

    function initValueSlider() {
        const isLargeScreen = $(window).width() > 1024;

        // Remove existing slick instance if it exists
        if ($(".valueListing").hasClass('slick-initialized')) {
            $(".valueListing").slick('unslick');
        }

        if (isLargeScreen) {
            $('.valueListing').css('display', 'flex');

            // Only run this once on large screens
            if (!hasRunOnLargeScreen) {
                hasRunOnLargeScreen = true;

                // This block runs ONLY ONCE when screen is large
                $(".valueListing .swiper-slide .listBox.active").removeClass("active");
                ourValuesBg(); // Assume this function manages background updates
            }
        } else {
            hasRunOnLargeScreen = false;
            $('.valueListing').css('display', 'block');
            $(".valueListing").slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                focusOnSelect: true,
                infinite: true,
                centerMode: false,
                rtl: $("html").attr("dir") === "rtl",
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });

            let activeSlide = 0;

            if ($('.valueListing .slick-slide.active').length === 0) {
                $('.valueListing .slick-slide[data-slick-index="0"]').addClass('active');
            } else {
                $('.valueListing .slick-slide').removeClass('active');
                $('.valueListing .slick-slide[data-slick-index="0"]').addClass('active');
            }

            $(".valueListing .slick-slide:not(.active) .listBody").stop(true, true).slideUp();
            $(".valueListing .slick-slide.active .listBody").stop(true, true).slideDown();
            $('.valueListing').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                if (activeSlide !== nextSlide) {
                    $(".listBody").stop(true, true).slideUp();
                    $('.valueListing .slick-slide').removeClass('active');
                    $('.valueListing .slick-slide[data-slick-index="' + nextSlide + '"]').addClass('active');
                    $('.valueListing .slick-slide[data-slick-index="' + nextSlide + '"] .listBody').stop(true, true).slideDown();
                    activeSlide = nextSlide;
                }
            });
        }
    }
    initValueSlider();

    let resizeTimeout;
    let previousWidth = window.innerWidth;

    window.addEventListener("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const currentWidth = window.innerWidth;
            if (currentWidth !== previousWidth) {
                previousWidth = currentWidth;
                initValueSlider();
            }
        }, 300);
    });

}

function calculateExpandWidth() {
    if (window.innerWidth > 767) {
        var totalSmallDivWidth = 0;
        $(".bp-card").each(function () {
            totalSmallDivWidth += $(this).width();
        });

        var containerWidth = $(".bp-body").width();
        var remainingWidth = containerWidth - totalSmallDivWidth;
        document.documentElement.style.setProperty(
            "--width-milestone-wrapper",
            `${remainingWidth}px`
        );
    }
}

function filterBoxDropdown() {
    var dropdown = $('.sortDropdown');
    $('.filterBox').click(function (event) {
        event.stopPropagation();
        if (dropdown.hasClass('active')) {
            dropdown.removeClass('active');
            dropdown.css('height', 0);
        } else {
            dropdown.addClass('active');
            var autoHeight = dropdown.prop('scrollHeight') + "px";
            dropdown.css('height', autoHeight);
        }
    });
    $(document).click(function () {
        if (dropdown.hasClass('active')) {
            dropdown.removeClass('active');
            dropdown.css('height', 0);
        }
    });
};

function smoothScrolling() {
    let isScrolling = false;
    $(".js-btn-list .item").on('click', function (event) {
        event.preventDefault();
        $(this).closest('.js-btn-list').find('.item').removeClass('active');
        $(this).addClass('active');
        var target = $(this).find('a').attr('href');
        var headerSpace = $('.header').outerHeight() || 0;
        if ($(target).length) {
            isScrolling = true;
            $('html, body').animate({
                scrollTop: $(target).offset().top - headerSpace
            }, 500, function () {
                history.replaceState(null, null, target);
                isScrolling = false;
            });
        }
    });
    $(window).on('scroll', function () {
        if (isScrolling) return;
        var headerSpace = $('.header').outerHeight() || 0;
        var viewportHeight = $(window).height();
        $('.js-btn-list .item').each(function () {
            var target = $(this).find('a').attr('href');
            var section = $(target);
            if (section.length) {
                var sectionTop = section.offset().top;
                var sectionHeight = section.outerHeight();
                var sectionVisiblePoint = sectionTop + (sectionHeight * 0.3);
                var scrollPosition = $(window).scrollTop() + headerSpace + viewportHeight / 2.5;
                if (scrollPosition >= sectionVisiblePoint) {
                    $('.js-btn-list .item').removeClass('active');
                    $(this).addClass('active');
                }
            }
        });
    });
}

function animBuildingProperity() {
    const prosperityTrigger = ScrollTrigger.getById("buildingProsperityTrigger");
    if (prosperityTrigger) prosperityTrigger.kill();
    if (window.innerWidth <= 1024) return;
    const trigerElem = document.querySelector(".building-prosperity-sec");
    const cards = document.querySelectorAll(".bp-card");
    const prevButton = document.querySelector('.building-prosperity-sec .swiper-button-prev');
    const nextButton = document.querySelector('.building-prosperity-sec .swiper-button-next');

    if (trigerElem) {
        const trigerElemHeight = trigerElem.clientHeight;
        let activeIndex = 0;
        const totalCards = cards.length;
        const tl = gsap.timeline({
            scrollTrigger: {
                id: "buildingProsperityTrigger",
                trigger: ".building-prosperity-sec .secSticky",
                start: window.innerWidth <= 1640 ? "top-=12% top" : "top-=8% top",
                end: () => "+=" + ((totalCards / 3) * trigerElemHeight),
                pin: true,
                scrub: true,
                markers: false,
                onUpdate: (self) => {
                    let progress = self.progress * (totalCards - 1);
                    activeIndex = Math.round(progress);
                    updateActiveCard();
                }
            }
        });

        cards.forEach((card, index) => {
            tl.to(card, { duration: 1 });
        });

        function updateActiveCard() {
            cards.forEach((card, index) => {
                if (index === activeIndex) {
                    card.classList.add("expanded");
                } else {
                    card.classList.remove("expanded");
                }
            });
        }

        if (nextButton && prevButton) {
            nextButton.addEventListener('click', () => {
                if (activeIndex < totalCards - 1) {
                    activeIndex++;
                    pinAndScrollToActiveCard();
                }
            });

            prevButton.addEventListener('click', () => {
                if (activeIndex > 0) {
                    activeIndex--;
                    pinAndScrollToActiveCard();
                }
            });
        }

        cards.forEach((card, index) => {
            card.addEventListener('click', () => {
                activeIndex = index;
                updateActiveCard();
                pinAndScrollToActiveCard();
            });
        });

        function pinAndScrollToActiveCard() {
            let progress = activeIndex / (totalCards - 1);
            let targetScrollPosition = progress * (tl.scrollTrigger.end - tl.scrollTrigger.start);

            gsap.to(window, {
                scrollTo: { y: tl.scrollTrigger.start + targetScrollPosition, autoKill: false },
                duration: 2,
                onComplete: () => {
                    ScrollTrigger.refresh();
                    updateActiveCard();
                }
            });
        }

        updateActiveCard();
    }
}

// validation works start here =====================
// Forms
function messageCharacterCount() {
    const textarea = $("textarea");
    if (textarea.length > 0) {
        function updateCharacterCount() {
            const currentCount = textarea.val().length;
            const charCount = $(".js-char-count");
            if (charCount.length > 0) {
                charCount.text(`${currentCount}/300`);
            }
        }
        textarea.on("keydown keyup", updateCharacterCount);
    }
}

function initSelect2(target) {
    var target = $(target);
    if (target) {
        target.each(function (i, e) {
            var tarPar = $(e).parent('.select-box');
            var tarPlace = $(e).data('placeholder');
            var dataClass = $(e).data('class');
            $(e).select2({
                minimumResultsForSearch: -1,
                placeholder: tarPlace,
            });
        });
    }
}

function intlTelInputInit() {
    const input = document.querySelectorAll(".phone-number-input");
    if (input && input.length > 0) {
        input.forEach(input => {
            var iti = window.intlTelInput(input, {
                separateDialCode: true,
                initialCountry: "SA"
            });
            window.iti = iti;
        })
    }
};

function validateForm() {
    // Get all the input fields with the class 'form-control'
    const inputs = $('.form-control');

    if (inputs) {

        let isValid = true;


        // Loop through input fields and check if they have values
        inputs.each((_, input) => {
            if (input.value === '') {
                isValid = false;
            }
        });

        // Check the checkboxes
        const checkBox = $('input[type="checkbox"]');
        checkBox.each((_, checkbox) => {
            if (!checkbox.checked) {
                isValid = false;
            }
        });

        if (isValid) {
            return true;
        } else {

            return false;
        }
    }
    // Initialize a flag to check if all 'form-control' fields have values

}

function footerScroll() {
    $(document).scroll(function (e) {
        var footerOffset = $('.footerSec').offset().top; // Get footer position from top
        var windowHeight = $(window).height(); // Get the height of the window
        var scrollPosition = $(window).scrollTop(); // Get current scroll position



        if (scrollPosition + windowHeight >= footerOffset - 0) {
            $('.footerSec').addClass('footer-show'); // Add class when footer is reached
        } else {
            $('.footerSec').removeClass('footer-show'); // Remove class if scrolled up
        }
    });
}

let stickyScrollTrigger;

function makeStickyEligibility() {
    const titleContent = document.querySelector(".stickyHeading");
    const eligibilitySection = document.querySelector(".eligibility-app-process");
    const rightContent = document.querySelector(".steps-content");


    if (window.innerWidth > 991) {
        if (titleContent && eligibilitySection && !stickyScrollTrigger) {
            stickyScrollTrigger = gsap.to(titleContent, {
                scrollTrigger: {
                    trigger: titleContent,
                    start: "top-=200 top",
                    end: `+=${eligibilitySection.offsetHeight - rightContent.offsetHeight + 500}`,
                    pin: true,
                    pinSpacing: false,
                    scrub: 1,
                    markers: false,
                },
            });
        }
    } else {

        if (stickyScrollTrigger) {
            stickyScrollTrigger.scrollTrigger.kill();
            stickyScrollTrigger = null;
        }
    }
}
window.addEventListener('load', makeStickyEligibility);
window.addEventListener('resize', makeStickyEligibility);

function makeStickyDetailNews() {
    const titleContent = document.querySelector(".inner--stickySideBar");
    const detailWrapper = document.querySelector(".news-detail-wrapper");
    const leftContent = document.querySelector(".wrapper-left");
    const headerHeight = document.querySelector('.header');

    // console.log(detailWrapper.offsetHeight, titleContent.offsetHeight);

    if (window.innerWidth > 767) {
        if (titleContent && detailWrapper && !stickyScrollTrigger) {
            stickyScrollTrigger = gsap.to(titleContent, {
                scrollTrigger: {
                    trigger: titleContent,
                    start: "top-=" + headerHeight.offsetHeight + " top",
                    end: `+=${detailWrapper.offsetHeight - titleContent.offsetHeight - 250}`,
                    pin: true,
                    pinSpacing: false,
                    scrub: 1,
                    markers: false,
                },
            });
        }
    } else {

        if (stickyScrollTrigger) {
            stickyScrollTrigger.scrollTrigger.kill();
            stickyScrollTrigger = null;
        }
    }
}

function progressBarClickItem() {

    const $slides = $('.swiper-year-slide');

    // Attach a click event listener to each slide
    $slides.on('click', function () {
        $('.swiper-year-slide').removeClass("visited");
        // Get the index of the clicked slide (1-based index)
        const targetSlide = $slides.index(this) + 1;
        const currentSlide = $('.year-navigation').attr('data-current-slide');

        // Log the index
        //console.log("Clicked index:", currentSlide);

        progressBarFill(currentSlide, targetSlide);

        $('.year-navigation').attr('data-current-slide', targetSlide);
    });



}

// Progress Bar 
function progressBarFill(currentSlide, targetSlide) {

    // console.log("Check 123");
    const currentSlide1 = currentSlide;
    const targetSlide1 = targetSlide;

    // console.log("Values : Current ", currentSlide1," :  Target ", targetSlide1);

    // 5 > 3
    if (targetSlide1 > currentSlide1) {
        // console.log("Check 1");

        for (var counter = 1; counter <= (targetSlide1); counter++) {
            // console.log("Item index : "+ counter);   
            $('.year-navigation').children().eq(counter).addClass('visited');
            // //console.log("Check 1" + counter );
        }

    } else if (targetSlide1 < currentSlide1) {

        // console.log("Check 2");
        for (var counter = targetSlide; counter >= 1; counter--) {
            // console.log("Item index : "+ counter);   
            $('.year-navigation').children().eq(counter).addClass('visited');
            // //console.log("Check 2" + counter );
        }
    }

}




